import { Box } from '@mui/material';
import { NoteDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { makePreloadedComponent } from '../../../ui/components/higher-order/preloaded.component';
import { NoteTooltip } from './note-tooltip.component';
import { NoteIcon, NoteProps } from './note.component';

export function MultipleNoteColumn({
  notes,
  iconSize,
  align,
  maxVisibleNotes
}: {
  notes: NoteDto[] | undefined;
  iconSize?: string;
  align?: 'left' | 'center' | 'right';
  maxVisibleNotes: number;
}) {
  // If there are no notifications then don't render anything
  if (!notes || notes.length === 0) {
    return <></>;
  }

  // Prepare the note props for rendering
  const notesListProps = makeNotesListProps(notes, iconSize, maxVisibleNotes);
  return (
    <Box
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : align
      }}
    >
      {notes.length > maxVisibleNotes && <span style={{ marginRight: '3px' }}>{notes.length - maxVisibleNotes}+</span>}
      {notesListProps.map((props) => {
        return <NoteIcon key={props.note.id} {...props} />;
      })}
    </Box>
  );
}

function makeNotesListProps(notes: NoteDto[], iconSize: string | undefined, maxVisible: number): NoteProps[] {
  // We want to order the notifications their date ascending, and then only show up until the maxVisible count.
  // This is because we want to show the most recent notifications first.
  notes = notes.sort((a, b) => {
    return a.createdTime.getTime() - b.createdTime.getTime();
  });

  // The array is already sorted in ascending order, so we can just slice the last maxVisible note (backwards)
  return notes.slice(-maxVisible).map((note) => {
    return {
      note,
      iconSize,
      tooltip: makePreloadedComponent(NoteTooltip, {
        note
      })
    };
  });
}
